/**
 * Created by nguyendx 2017/10/26.
 */
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class EvsAddressService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  getCountries() {
    return this.get('/countries');
  }
  getCities() {
    // return this.getFullUrl(environment.api + '/cities'); // Lấy theo affiliate
    return this.get('/cities');
  }

  getDistrict(data?: any) {
    // return this.getFullUrl(environment.api + '/districts', data); // Lấy theo affiliate
    return this.get('/districts', data);
  }

  getStatus() {
    return this.get('/status');
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/EvsAddress.service.ts